/* eslint-disable max-len */
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import Select, { createFilter } from 'react-select';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as action from '../action';
import * as c from '../constant';

function UpdateModal({
  setFormData,
  formData,
  updateUserManagement,
  showUserManagement,
  history,
  id,
  updating,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateUserManagement(id, formData, ({ data }) => {
      setModal({ isOpen: false });
      showUserManagement(id);
      history.push(`/general-settings/billing-imports/${_.get(data, 'id')}`);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="form-group col-12">
            <label htmlFor="zone" className="full-label mb-0">
              Source
            </label>
            <Select
              filterOption={createFilter({
                ignoreAccents: false,
              })}
              name="source"
              placeholder="Select Source Type"
              onChange={handleChangeSelect('source')}
              options={c.SOURCE}
              value={
                _.get(formData, 'source')
                  ? {
                      value: _.get(formData, 'source'),
                      label: _.get(formData, 'source'),
                    }
                  : { value: '', label: 'Please Select a source type' }
              }
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateUserManagement: PropTypes.instanceOf(Function).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  // createInputNumber: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_SETTING) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
